import { render, staticRenderFns } from "./RedBook.vue?vue&type=template&id=4d5f00e4&scoped=true"
import script from "./RedBook.vue?vue&type=script&lang=js"
export * from "./RedBook.vue?vue&type=script&lang=js"
import style0 from "./RedBook.vue?vue&type=style&index=0&id=4d5f00e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f00e4",
  null
  
)

export default component.exports